export enum FormFields {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  Radius = 'radius',
  AgencyName = 'agencyName',
  AgencyWebsite = 'agencyWebsite',
  SubscriptionPlanName = 'subscriptionPlanName',
  SubscriptionPlanStatus = 'subscriptionPlanStatus',
  SubscriptionType = 'subscriptionType',
  IsRealUser = 'isRealUser',
  ExcludeFromReports = 'excludeFromReports',
  DemoExpirationDate = 'demoExpirationDate',
  UserStatus = 'userStatus',
  Place = 'place',
}

export const FormFieldsList = [
  FormFields.FirstName,
  FormFields.LastName,
  FormFields.Email,
  FormFields.PhoneNumber,
  FormFields.Radius,
  FormFields.AgencyName,
  FormFields.AgencyWebsite,
  FormFields.SubscriptionPlanName,
  FormFields.SubscriptionPlanStatus,
  FormFields.SubscriptionType,
  FormFields.IsRealUser,
  FormFields.ExcludeFromReports,
  FormFields.DemoExpirationDate,
  FormFields.UserStatus,
  FormFields.Place,
];
